import React from 'react';
import Button from '../../../../muiComponents/Button';
import useTranslate from '../../../../customHooks/useTranslate';
import FiltersBar from '../../../../Table/FiltersBar';
import ChangeViewButtonBar from '../../../../Table/ChangeViewButtonBar';
import { useContractsList } from '../../../contextsProperty/ContextContractsList';
import { ContractsListViewType } from '../../../../types/contracts/contractTypes';
import { commonIcons } from '../../../../utils/commonVariables/commonIcons';
import GridChild from '../../../../muiComponents/GridChild';
import Grid from '../../../../muiComponents/Grid';
import TextInput from '../../../../muiComponents/TextInput/TextInput';
import LoadedOptionsTypeahead from '../../../../muiComponents/LoadedOptionsTypeahead';
import { useContractsComplementaryData } from '../../../contextsProperty/ContextContractsList';
import { IFilterOptionState } from '../../../../types/lists/listTypes';
import {
    doubleLG_ColumnGrid,
    gridSpacing10,
    gridSpacing15,
    singleLG_DoubleSM_ColumnGrid,
} from '../../../../utils/commonVariables/grid';
import { useHistory } from 'react-router-dom';
import encodeBase64 from '../../../../utils/encodeBase64';
import Tooltip from '../../../../muiComponents/Tooltip';
import useUserProfile from '../../../../customHooks/useUserProfile';

const ContractsFiltersBar = () => {
    const translate = useTranslate();
    const history = useHistory();
    const { readOnlyUser } = useUserProfile();

    const {
        handleFilterChange,
        filters,
        handleSearch,
        resetFilters,
        isLoading,
        currentResults,
        totalResults,
        visibleView,
        changeVisibleView,
    } = useContractsList();

    const { supplierHotels, agencies } = useContractsComplementaryData();

    const buttonsButtonBar = [
        {
            icon:
                visibleView === ContractsListViewType.CALENDAR
                    ? commonIcons.LIST
                    : commonIcons.CALENDAR,
            label:
                visibleView === ContractsListViewType.CALENDAR
                    ? 'list'
                    : 'calendar',
            view:
                visibleView === ContractsListViewType.CALENDAR
                    ? ContractsListViewType.TABLE
                    : ContractsListViewType.CALENDAR,
        },
    ];

    const handleAddSupplement = () => {
        const currentPath = history.location.pathname;
        history.push(`${currentPath}/${encodeBase64('new')}`);
    };

    return (
        <FiltersBar
            title='contracts'
            clearFilters={resetFilters}
            search={async () => await handleSearch(1)}
            isLoading={isLoading}
            currentResults={currentResults}
            totalResults={totalResults}
            startButtonBar={
                <Tooltip
                    titleText='read_only_contracts'
                    hideTooltip={!readOnlyUser}
                >
                    <span>
                        <Button
                            variant='contained'
                            startIcon='Add'
                            onClick={handleAddSupplement}
                            disabled={readOnlyUser}
                        >
                            {translate('add')}
                        </Button>
                    </span>
                </Tooltip>
            }
            endButtonBar={
                <ChangeViewButtonBar
                    changeVisibleView={(view: string) =>
                        changeVisibleView(view as ContractsListViewType)
                    }
                    buttons={buttonsButtonBar}
                />
            }
        >
            <Grid
                className='flex-grow'
                columnSpacing={gridSpacing10}
                rowSpacing={gridSpacing15}
            >
                <GridChild gridProps={doubleLG_ColumnGrid}>
                    <TextInput
                        labelText={'name'}
                        id={'name'}
                        value={filters.Name.value || ''}
                        handleChange={(
                            e: React.SyntheticEvent<Element, Event>,
                            newValue: string
                        ) => handleFilterChange('Name', newValue)}
                        onKeyPress={async (e: React.KeyboardEvent) => {
                            if (e.key === 'Enter') {
                                await handleSearch(1);
                            }
                        }}
                    />
                </GridChild>
                <GridChild gridProps={singleLG_DoubleSM_ColumnGrid}>
                    <LoadedOptionsTypeahead
                        labelText={'hotel'}
                        options={supplierHotels.data || []}
                        value={filters.IdSupplierHotel.value || null}
                        handleChange={(
                            e: React.SyntheticEvent<Element, Event>,
                            newValue: IFilterOptionState | null
                        ) => handleFilterChange('IdSupplierHotel', newValue)}
                        disabled={supplierHotels.isLoading}
                    />
                </GridChild>
                <GridChild gridProps={singleLG_DoubleSM_ColumnGrid}>
                    <LoadedOptionsTypeahead
                        labelText={'agency'}
                        options={agencies.data || []}
                        value={filters.IdAgency.value || null}
                        handleChange={(
                            e: React.SyntheticEvent<Element, Event>,
                            newValue: IFilterOptionState | null
                        ) => handleFilterChange('IdAgency', newValue)}
                        disabled={
                            agencies.isLoading || !filters.IdSupplierHotel.value
                        }
                    />
                </GridChild>
            </Grid>
        </FiltersBar>
    );
};

export default ContractsFiltersBar;
